export default `---
slug: germany
country: Germany
countryCode: DEU
continent: Europe
year: 2006
title: "Germany"
description: "From the 2006 World Cup stopover to Oktoberfest — Germany never disappoints."
thumbnail: /images/travels/DEU/germany_thumb.jpg
relatedLinks: []
---
![germany](/images/travels/DEU/germany_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Germany and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
